// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-search{padding:32px 0}.b-search__wrap{display:flex;flex-wrap:wrap;justify-content:flex-start;margin:0 -12px}.b-search__wrap .goods-card{width:calc(50% - 24px);margin:0 12px;margin-bottom:24px}@media only screen and (min-width:639px){.b-search__wrap .goods-card{width:calc(33.33333% - 24px)}}@media only screen and (min-width:992px){.b-search__wrap .goods-card{width:calc(25% - 24px)}}.b-search__wrap--loading{opacity:.3}", ""]);
// Exports
module.exports = exports;
